import * as React from "react";
import { Modal as AntModal, Divider } from "antd";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Modal = props => {
    const { visible, children, ...propsToPropagate } = props;
    React.useEffect(() => {
        if (visible === true) {
            const beforeUnloadCallback = e => {
                e.preventDefault();
                return e.returnValue = "";
            };
            window.addEventListener("beforeunload", beforeUnloadCallback);
            return () => {
                window.removeEventListener("beforeunload", beforeUnloadCallback);
            };
        }
    }, [visible]);
    return /*#__PURE__*/ _jsxs(AntModal, {
        maskClosable: false,
        open: visible,
        ...propsToPropagate,
        children: [/*#__PURE__*/ _jsx(Divider, {}), children]
    });
};
export { Modal };
